(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[id^="lp-testimonials-"]';

    const initSection = (section) => {
      if (!section || section.dataset.lpTestimonialsVideoInit === 'true') {
        return;
      }
      section.dataset.lpTestimonialsVideoInit = 'true';

      section.addEventListener('click', (event) => {
        const trigger = event.target.closest('.lp-testimonial-card__video-trigger');
        if (!trigger || !section.contains(trigger)) {
          return;
        }

        const imageWrap = trigger.closest('.lp-testimonial-card__image-wrap');
        const player = imageWrap ? imageWrap.querySelector('.lp-testimonial-card__video-player') : null;
        if (!player) {
          return;
        }

        trigger.hidden = true;
        player.hidden = false;

        const video = player.querySelector('video');
        if (!video) {
          return;
        }

        video.currentTime = 0;
        const playResult = video.play();
        if (playResult && typeof playResult.catch === 'function') {
          playResult.catch(() => {});
        }
      });
    };

    const initAllSections = () => {
      document.querySelectorAll(sectionSelector).forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllSections);
    } else {
      initAllSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
